<template>
  <b-card>
    <b-card-header>
      <h3>{{msg}}</h3>
    </b-card-header>
    <b-card-body>
      <initiative-tracker></initiative-tracker>
    </b-card-body>
  </b-card>
</template>

<script>
import InitiativeTracker from '@/components/InitiativeTracker'
export default {
  name: 'ShadowRunView',
  data () {
    return {
      msg: 'Shadow Run Resources'
    }
  },
  components: { InitiativeTracker }
}
</script>

<style scoped>
  p {
    font-style: italic;
  }
</style>
